import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const LockIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.39922 5.86823V5.25871C4.39922 3.23276 6.00493 1.60156 7.99922 1.60156C9.9935 1.60156 11.5992 3.23276 11.5992 5.25871V5.86823M4.39922 5.86823C3.73922 5.86823 3.19922 6.4168 3.19922 7.08728V13.1825C3.19922 13.853 3.73922 14.4016 4.39922 14.4016H11.5992C12.2592 14.4016 12.7992 13.853 12.7992 13.1825V7.08728C12.7992 6.4168 12.2592 5.86823 11.5992 5.86823M4.39922 5.86823H11.5992M7.99922 10.8016V9.20156"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </BaseIcon>
  );
};

LockIcon.displayName = 'LockIcon';
